import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './DeferDeleteSuccess.scss';

import { AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS } from '../../../redux/modules/modals/modals.module';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import Button from '../../Shared/Button/Button';
import { isProductType529 } from '../../../utils/funds/funds-utility';
import successImg from 'src/assets/images/success.png';

class DeferDeleteSuccess extends Component {
  componentDidMount() {
    const { dispatchPageLoad, fund, type, actionType } = this.props;
    const modalName = isProductType529(fund.productType)
      ? actionType === 'delete'
        ? 'College|Contribute|DeleteSuccessModal'
        : actionType === 'skip'
        ? 'College|Contribute|SkipSuccessModal'
        : 'College|Contribute|SkipCancelSuccessModal'
      : actionType === 'delete'
      ? `${type}|DeleteSuccessModal`
      : actionType === 'skip'
      ? `${type}|SkipSuccessModal`
      : 'Buy|SkipCancelSuccessModal';
    dispatchPageLoad(modalName);
  }

  render() {
    const { closeModal, getHasCollegeOnly, type } = this.props;
    return (
      <div>
        <div className="defer-delete-success-image-container">
          <img src={successImg} alt="success" />
        </div>
        <div className="defer-delete-success-title">
          Changes to your
          {getHasCollegeOnly
            ? 'Monthly Contribution'
            : type.includes('Auto-Max')
            ? `${' '}${type}`
            : `${' '}Automatic ${type}`}{' '}
          have been submitted.
        </div>
        <div className="defer-delete-success-button-container">
          <Button
            className="defer-delete-success-button"
            buttonType="primary"
            styleName="defer-delete-success-button"
            disabled={false}
            id="delete-btn"
            onClick={() =>
              closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS)
            }
          >
            Ok
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getHasCollegeOnly: getHasCollegeOnly(state),
  };
};

export default compose(connect(mapStateToProps))(DeferDeleteSuccess);
